<template>
    <div class="u_tops">
        <div class="box">
            <div class="flex">
                <el-menu
                    :default-active="onRoutes"
                    router
                    unique-opened
                    class="el_menu"
                    background-color="#404040"
                    text-color="#ffffff"
                    active-text-color="#ffffff"
                >
                    <template v-for="item in items">
                        <template v-if="item.subs&&item.isShow">
                            <el-submenu :index="item.index + ''" :key="item.index" class="submenu">
                                <template slot="title">
                                    <div class="flexCenter img_box1">
                                        <img :src="item.img_1" alt="" class="img_is" />
                                        <span class="items_title">{{ item.title }}</span>
                                    </div>
                                </template>

                                <template v-for="subItem in item.subs">
                                    <!-- 如果有三级 -->
                                    <template v-if="subItem.subs&&subItem.isShow">
                                        <el-submenu :index="subItem.index + ''" :key="subItem.index" class="submenu">
                                            <template slot="title">
                                                <div class="flexCenter img_box1 img_box">
                                                    <img :src="subItem.img_1" alt="" class="img_i" />
                                                    <span class="items_title">{{ subItem.title }}</span>
                                                </div>
                                            </template>
                                            <template v-for="subItems in subItem.subs">
                                                <template v-if="subItems.isShow">
                                                    <el-menu-item class="menu_item" :index="subItems.index + ''" :key="subItems.index">
                                                        <div
                                                            class="flexCenter img_box1 img_box2"
                                                            :class="onRoutes == subItems.index ? 'is_active' : ''"
                                                        >
                                                            <!-- <img :src="subItems.img" alt="" class="img_i" /> -->
                                                            <span class="items_title">{{ subItems.title }}</span>
                                                        </div>
                                                    </el-menu-item>
                                                </template>
                                            </template>
                                        </el-submenu>
                                    </template>
                                    <!-- 只有二级 -->
                                    <template v-else>
                                        <template v-if="subItem.isShow">
                                        <el-menu-item class="menu_item" :index="subItem.index + ''" :key="subItem.index">
                                            <div class="flexCenter img_box1 img_box" :class="onRoutes == subItem.index ? 'is_active' : ''">
                                                <img :src="subItem.img" alt="" class="img_i" />
                                                <span class="items_title">{{ subItem.title }}</span>
                                            </div>
                                        </el-menu-item>
                                    </template>
                                    </template>
                                    
                                </template>
                            </el-submenu>
                        </template>
                        <template v-else>
                            <el-menu-item :index="item.index + ''" :key="item.index">
                                <div class="flexCenter img_box1" :class="onRoutes == item.index ? 'is_active' : ''">
                                    <img :src="item.img_1" alt="" class="img_is" />
                                    <span class="items_title">{{ item.title }}</span>
                                </div>
                            </el-menu-item> 
                        </template>
                    </template>
                </el-menu>
                <div class="w5"></div>
                <div class="newItem1"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
       
    },
    data() {
        return {
            logo: require('@/assets/img/logo.png'),
            user_type: '',
            items: [
                {
                 
                    img_1: require('@/assets/img/1.png'),
                    index: 'workbench',
                    title: '首页',
                    roles: 'homepage',
                    isShow: false
                },
                {
                    index: 'index',
                    img_1: require('@/assets/img/2.png'),
                    title: '商城管理',
                    isShow: false,
                    subs: [
                        {
                            index: 'acces',
                            title: '积分数据',
                            roles: 'integral',
                            img: require('@/assets/img/right.png'),
                            isShow: false
                        },
                        {
                            index: 'index',
                            title: '仪表盘首页',
                            roles: 'homepage1',
                            img: require('@/assets/img/right.png'),
                            isShow: false
                        },
                        {
                            index: 'storeOrders',
                            img_1: require('@/assets/img/right.png'),
                            title: '积分订单',
                            isShow: false,
                            subs: [
                                {
                                    index: 'storeOrders',
                                    title: '门店订单',
                                    roles: 'storeorder',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                },
                                {
                                    index: 'consumerOrders',
                                    title: '消费者订单',
                                    roles: 'userorder',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                }
                            ]
                        },
                        {
                           
                            index: 'productList',
                            img_1: require('@/assets/img/right.png'),
                            title: '商品管理',
                            isShow: false,
                            subs: [
                                {
                                    index: 'productList',
                                    title: '商品列表',
                                    roles: 'goods',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                },
                                {
                                    index: 'classificationManagement',
                                    title: '分类管理',
                                    roles: 'goodscategory',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                }
                            ]
                        },
                        {
                            index: 'rotatingPoster',
                            title: '轮播海报',
                            roles: 'posterconfig',
                            img: require('@/assets/img/right.png'),
                            isShow: false
                        },
                        {
                            index: 'coverConfiguration',
                            img: require('@/assets/img/right.png'),
                            img_1: require('@/assets/img/right.png'),
                            title: '动态分享',
                            isShow: false,
                            subs: [
                                {
                                    index: 'coverConfiguration',
                                    title: '封面配置',
                                    roles: 'coverconfig',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                },
                                {
                                    index: 'activitySettings',
                                    title: '活动设置', 
                                    roles: 'activityconfig',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                },
                                { 
                                    index: 'dynamicSettings',
                                    title: '动态审核',
                                    roles: 'userarticle',
                                    img: require('@/assets/img/right.png'),
                                    isShow: false
                                },
                            ]
                        },
                        {
                            index: 'user',
                            title: '会员列表',
                            roles: 'user',
                            img: require('@/assets/img/right.png'),
                            isShow: false
                        },
                    ]
                },

                {
                    img_1: require('@/assets/img/3.png'),
                    index: 'order',
                    title: '二维码管理',
                    isShow: false,
                    subs: [
                        {
                            index: 'order',
                            title: '公司信息',
                            roles: 'company',
                            img: require('@/assets/img/right.png'),
                            isShow: false
                        },
                        {
                            index: 'aftersalesorder',
                            title: '产品管理',
                            roles: 'product',
                            img: require('@/assets/img/right.png'),

                            isShow: false
                        },
                        {
                            index: 'productevaluation',
                            img: require('@/assets/img/right.png'),

                            title: '二维码申请记录',
                            roles: 'labelapply',
                            isShow: false
                        }
                    ]
                },
                {
                    img_1: require('@/assets/img/4.png'),
                    index: 'product',
                    title: '出入库明细',
                    isShow: false,
                    subs: [
                        {
                            index: 'product',
                            title: '入库明细',
                            img: require('@/assets/img/right.png'),
                            roles: 'inbounddata',
                            isShow: false
                        },
                        {
                            index: 'productinoutbound',
                            img: require('@/assets/img/right.png'),

                            title: '出库明细',
                            roles: 'outbounddata',
                            isShow: false
                        }
                      
                    ]
                },
                {
                    img_1: require('@/assets/img/4.png'),
                    index: 'pda',
                    title: '出库管理',
                    isShow: false,
                    subs: [
                        {
                            index: 'pda',
                            title: '出库',
                            img: require('@/assets/img/right.png'),
                            roles: 'pda',
                            isShow: false
                        },
                        {
                            index: 'return',
                            title: '取消出库',
                            img: require('@/assets/img/right.png'),
                            roles: 'pda',
                            isShow: false
                        },
                        // {
                        //     index: 'productinoutbound',
                        //     img: require('@/assets/img/right.png'),

                        //     title: '出库明细',
                        //     roles: 'pda',
                        //     isShow: false
                        // }
                      
                    ]
                },
               
                {
            
                    img_1: require('@/assets/img/5.png'),
                    index: 'coupons',
                    title: '渠道管理',
                    isShow: false,
                    subs: [
                        {
                            index: 'coupons',
                            title: '代理商管理',
                            img: require('@/assets/img/right.png'),
                            isShow: false,
                            roles: 'saleagent'
                        },
                        {
                            index: 'fulldeliveryactivity',
                            img: require('@/assets/img/right.png'),

                            title: '代理商库存',
                            isShow: false,
                            roles: 'saleagentinventory'
                        },
                        {
                            index: 'store',
                            img: require('@/assets/img/right.png'),
                            title: '门店管理',
                            isShow: false,
                            roles: 'store'
                        },
                        {
                            index: 'warehousing',
                            img: require('@/assets/img/right.png'),
                            title: '门店入库',
                            isShow: false,
                            roles: 'storeinbounddata'
                        }
                    ]
                },

                {
               
                    img_1: require('@/assets/img/6.png'),
                    index: 'userList',
                    title: '窜货数据',
                    isShow: false,
                    subs: [
                        {
                            index: 'userList',
                            title: '代理商窜货统计',
                            img: require('@/assets/img/right.png'),

                            isShow: false,
                            roles: 'saleagentch'
                        },
                        {
                            index: 'userlabel',
                            img: require('@/assets/img/right.png'),

                            title: '窜货二维码明细',
                            isShow: false,
                            roles: 'abnormalscanlabellog'
                        }
                    ]
                },
                {
                    index: 'invoice',
               
                    img_1: require('@/assets/img/7.png'),
                    isShow: false,
                    roles: 'labelquery',
                    title: '二维码查询'
                },
             
                {
                    index: 'clientuser',
                    img_1: require('@/assets/img/8.png'),
                    title: '员工管理',
                    isShow: false,
                    roles: 'clientuser',

                },
                {

                    index: 'wechatconfig',
                    img_1: require('@/assets/img/9.png'),
                    title: '微信配置',
                    isShow: false,
                    roles: 'wechatconfig',
                        },
            ],
         
        };
    },

    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        let auth_info = localStorage.getItem('auth_info');
        let path = this.$route.path.replace('/', '');
        let roleList = JSON.parse(auth_info); //登录获取的权限
        // this.items  路由配置的权限
        this.items.forEach((item, index1) => {
            roleList.forEach((item2, index2) => {
                if (item.subs) {
                    item.subs.forEach((item3, index3) => {
                        if (item3.subs) {
                       
                            item3.subs.forEach((item4, index4) => {
                                if (item4.roles == item2) {
                                    this.items[index1].subs[index3].subs[index4].isShow = true;
                                    this.items[index1].subs[index3].isShow = true;
                                    this.items[index1].isShow = true;
                                }
                            });
                        } else {
                            if (item3.roles == item2) {
                                this.items[index1].subs[index3].isShow = true;
                                this.items[index1].isShow = true;
                            }
                        }
                    });
                } else {
                    if (item.roles == item2) {
                        this.items[index1].isShow = true;
                    }
                }
            });
        });
        let a = this.items.filter((val) => val.isShow == true);
        if (path == '') {
            this.$router.push(a[0].index);
        }
        // console.log('a :>> ', a);
    
        this.items = a;
      
    },
    methods: {
        handleCommand() {
            let that=this
            that.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    //点击确定的操作(调用接口)
                    localStorage.removeItem('user');
                    localStorage.removeItem('auth_info');
                    localStorage.removeItem('token');
                    localStorage.removeItem('pdaToken');
                    // localStorage.removeItem('area');
                    localStorage.removeItem('items');
                    localStorage.removeItem('role_permission_info');
                    that.$router.replace('/login');
                })
                .catch(() => {});
        }
    }
};
</script>
<style>
.img_is{
    width: 18px;
    height: 18px;
}
.el-tooltip__popper {
    color: #000 !important;
}
</style>
<style scoped lang="scss">
.flex {
    display: flex;
}

.flexCenter1 {
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 15px;
    left: 9px;
    position: absolute;
}
.no_loginImg {
    width: 18px;
    height: 18px;
}
.newItem1 {
    width: 0;
    border-right: 1px solid #212121;
}
.items_title {
    font-size: 12px;
    font-weight: 400;
    color: rgba(235, 235, 235, 1);
    line-height: 12px;
    cursor: pointer;
    margin-left: 5px;
}
.newItem {
    border-right: 1px solid #212121;
    border-left: 1px solid #212121;
    // background: rgba(64, 64, 64, 1);
    width: 248px;
    .newItem_title {
        width: 248px;
        padding: 0 12px;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #212121;
        background: rgba(77, 77, 77, 1);
        img {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
        img:hover {
            // order-radius: 1px;
        }
        span {
            font-size: 20px;
            font-weight: 400;
            line-height: 21px;
            color: rgba(235, 235, 235, 1);
        }
    }
    .newItem_subs {
        width: 248px;
        padding: 16px 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #212121;
        img {
            width: 16px;
            height: 16px;
            margin-right: 6px;
            cursor: pointer;
        }
        span {
            font-size: 12px;
            font-weight: 400;
            color: rgba(235, 235, 235, 1);
            line-height: 12px;
            cursor: pointer;
        }
    }
    .newItem_subs1 {
        background: rgba(77, 77, 77, 1) !important;
    }
}

.u_tops {
    display: flex;
}
.w5 {
    width: 5px;
    height: 100vh;
    background: rgba(77, 77, 77, 1);
}
.ml15 {
    margin-left: 15px;
}
/deep/.el-submenu__title {
    padding: 0 !important;
    height: 43px !important;
}
/deep/.el-menu-item,
.el-submenu__title {
    height: 43px !important;
}

/deep/.el-submenu__icon-arrow {
    // display: none;
    color: #fff;
}
/deep/.el-dropdown-menu__item,
.el-menu-item {
    padding: 0 !important;
}

.box {
    width: 151px;
    height: 100vh;
    left: 0px;
    top: 35px;
    background: rgb(64, 64, 64);
    bottom: 0;
    overflow-y: scroll;
    -webkit-transition: left 0.3s ease-in-out;
    transition: left 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .el_menu {
        border-right: none;
        overflow: auto;
        flex: 1;
    }

    .flexCenter_center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .w36 {
        width: 100%;
        height: 43px;
        background: rgba(77, 77, 77, 1);
    }
    .img_box1 {
        padding-left: 10px;
        height: 42px;

        margin: 0 0px 1px 0;
        // background: rgba(77, 77, 77, 1);
    }
    .img_box { 
        padding-left: 25px;

        border-right: none !important;
    }
    .img_box2{
        padding-left: 33px;
        // padding-left: 45px;

border-right: none !important;
    }
    .img_i {
        width: 8px;
        height: 12px;
    }
}

::-webkit-scrollbar {
    display: none;
}
/deep/.el_menu :hover {
    // background: none !important;
}

/deep/.el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.el-form-item__label {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 14px;
    color: #21272a;
}

/deep/.v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
.is_active {
    background: rgba(77, 77, 77, 1) !important;
}
</style>
